/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import Icon from '@ant-design/icons';

function InlinePlaySvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_598_9206)">
        <path
          d="M5.90252 9.58811L9.01814 7.13967C9.03897 7.12314 9.05579 7.10212 9.06735 7.07817C9.07892 7.05423 9.08492 7.02798 9.08492 7.00139C9.08492 6.9748 9.07892 6.94855 9.06735 6.92461C9.05579 6.90067 9.03897 6.87964 9.01814 6.86311L5.90252 4.41311C5.78689 4.32248 5.61658 4.40373 5.61658 4.55061V9.44905C5.61658 9.59592 5.78689 9.67873 5.90252 9.58811Z"
          fill="currentColor"
        />
        <path
          d="M12.7417 0.751953H1.2417C0.965137 0.751953 0.741699 0.975391 0.741699 1.25195V12.752C0.741699 13.0285 0.965137 13.252 1.2417 13.252H12.7417C13.0183 13.252 13.2417 13.0285 13.2417 12.752V1.25195C13.2417 0.975391 13.0183 0.751953 12.7417 0.751953ZM12.1167 12.127H1.8667V1.87695H12.1167V12.127Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_598_9206">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(-0.00854492)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function InlinePlayIcon(props: {
  style?: React.CSSProperties;
  className?: string;
}) {
  return <Icon component={InlinePlaySvg} {...props} />;
}
